if (!customElements.get('best-sellers-tabs')) {
  class BestSellersTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        if (this.onBlockSelect) {
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        return;
      }

      this.initialized = true;

      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activateTab(tab, {
            focus: false,
            scrollTab: true
          });
        });

        tab.addEventListener('keydown', (event) => {
          this.onTabKeydown(event);
        });
      });

      this.onBlockSelect = (event) => {
        const selectedTab =
          event.target instanceof Element
            ? event.target.closest('[role="tab"]')
            : null;

        if (!selectedTab || !this.contains(selectedTab)) {
          return;
        }

        this.activateTab(selectedTab, {
          focus: false,
          scrollTab: true
        });
      };

      document.addEventListener('shopify:block:select', this.onBlockSelect);

      const activeTab =
        this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
        this.tabs[0];

      if (activeTab) {
        this.activateTab(activeTab, {
          focus: false,
          scrollTab: true
        });
      }
    }

    disconnectedCallback() {
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    activateTab(tab, options = {}) {
      const targetId = tab.dataset.tabTarget;

      const activePanel = this.panels.find(
        (panel) => panel.dataset.tabPanel === targetId
      );

      if (!activePanel) {
        return;
      }

      this.tabs.forEach((item) => {
        const isActive = item === tab;

        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel !== activePanel;
      });

      this.resetCarousel(activePanel);

      if (options.focus) {
        tab.focus();
      }

      if (options.scrollTab) {
        this.scrollTabIntoView(tab);
      }
    }

    resetCarousel(panel) {
  const carousel = panel.querySelector('slider-component');
  const track = panel.querySelector('.best-sellers-tabs__track');
  const currentCounter = panel.querySelector('.slider-counter--current');

  if (track) {
    const previousScrollBehavior = track.style.scrollBehavior;

    track.style.scrollBehavior = 'auto';
    track.scrollLeft = 0;
    track.style.scrollBehavior = previousScrollBehavior;
  }

  if (currentCounter) {
    currentCounter.textContent = '1';
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (carousel && typeof carousel.resetPages === 'function') {
        carousel.resetPages();
      }
    });
  });
}

    scrollTabIntoView(tab) {
      if (
        !this.tablist ||
        this.tablist.scrollWidth <= this.tablist.clientWidth
      ) {
        return;
      }

      const tabStart = tab.offsetLeft;
      const tabEnd = tabStart + tab.offsetWidth;

      const visibleStart = this.tablist.scrollLeft;
      const visibleEnd = visibleStart + this.tablist.clientWidth;

      let targetLeft = visibleStart;

      if (tabStart < visibleStart) {
        targetLeft = tabStart;
      } else if (tabEnd > visibleEnd) {
        targetLeft = tabEnd - this.tablist.clientWidth;
      }

      if (targetLeft === visibleStart) {
        return;
      }

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.tablist.scrollTo({
        left: targetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    onTabKeydown(event) {
      const supportedKeys = [
        'ArrowLeft',
        'ArrowRight',
        'Home',
        'End'
      ];

      if (!supportedKeys.includes(event.key)) {
        return;
      }

      event.preventDefault();

      const currentIndex = this.tabs.indexOf(event.currentTarget);

      if (currentIndex === -1) {
        return;
      }

      let targetIndex = currentIndex;

      if (event.key === 'Home') {
        targetIndex = 0;
      }

      if (event.key === 'End') {
        targetIndex = this.tabs.length - 1;
      }

      if (event.key === 'ArrowLeft') {
        targetIndex =
          (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      }

      if (event.key === 'ArrowRight') {
        targetIndex =
          (currentIndex + 1) % this.tabs.length;
      }

      this.activateTab(this.tabs[targetIndex], {
        focus: true,
        scrollTab: true
      });
    }
  }

  customElements.define('best-sellers-tabs', BestSellersTabs);
}
